const translations = {
    logOut: 'Log Out'
};

export default translations;
